module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-panel weui-panel_access"
  }, [(_vm.header) ? _c('div', {
    staticClass: "weui-panel__hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    },
    on: {
      "click": _vm.onClickHeader
    }
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__bd"
  }, [_vm._t("body", function() {
    return [(_vm.type === '1') ? _vm._l((_vm.list), function(item) {
      return _c('a', {
        staticClass: "weui-media-box weui-media-box_appmsg",
        attrs: {
          "href": _vm.getUrl(item.url)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [(item.src) ? _c('div', {
        staticClass: "weui-media-box__hd"
      }, [_c('img', {
        staticClass: "weui-media-box__thumb",
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "weui-media-box__bd"
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '2') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '3') ? [_c('div', {
      staticClass: "weui-media-box weui-media-box_small-appmsg"
    }, [_c('div', {
      staticClass: "weui-cells"
    }, _vm._l((_vm.list), function(item) {
      return _c('a', {
        staticClass: "weui-cell weui-cell_access",
        attrs: {
          "href": _vm.getUrl(item.url)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('div', {
        staticClass: "weui-cell__hd"
      }, [_c('img', {
        staticStyle: {
          "width": "20px",
          "margin-right": "5px",
          "display": "block"
        },
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "weui-cell__bd"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "weui-cell__ft"
      })])
    }), 0)])] : _vm._e(), _vm._v(" "), (_vm.type === '4') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      }), _vm._v(" "), (item.meta) ? _c('ul', {
        staticClass: "weui-media-box__info"
      }, [_c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.source)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.date)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta weui-media-box__info__meta_extra",
        domProps: {
          "innerHTML": _vm._s(item.meta.other)
        }
      })]) : _vm._e()])
    }) : _vm._e(), _vm._v(" "), (_vm.type === '5') ? _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "weui-media-box weui-media-box_text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.onItemClick(item)
          }
        }
      }, [_c('div', {
        staticClass: "weui-media-box_appmsg"
      }, [(item.src) ? _c('div', {
        staticClass: "weui-media-box__hd"
      }, [_c('img', {
        staticClass: "weui-media-box__thumb",
        attrs: {
          "src": item.src,
          "alt": ""
        },
        on: {
          "error": function($event) {
            return _vm.onImgError(item, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "weui-media-box__bd"
      }, [_c('h4', {
        staticClass: "weui-media-box__title",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "weui-media-box__desc",
        domProps: {
          "innerHTML": _vm._s(item.desc)
        }
      })])]), _vm._v(" "), (item.meta) ? _c('ul', {
        staticClass: "weui-media-box__info"
      }, [_c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.source)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta",
        domProps: {
          "innerHTML": _vm._s(item.meta.date)
        }
      }), _vm._v(" "), _c('li', {
        staticClass: "weui-media-box__info__meta weui-media-box__info__meta_extra",
        domProps: {
          "innerHTML": _vm._s(item.meta.other)
        }
      })]) : _vm._e()])
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__ft"
  }, [(_vm.footer && _vm.footer.title && _vm.type !== '3') ? _c('a', {
    staticClass: "weui-cell weui-cell_access weui-cell_link",
    attrs: {
      "href": _vm.getUrl(_vm.footer.url)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickFooter.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a31cc69","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/panel/index.vue
// module id = 314
// module chunks = 1